/* src/app/dashboard/ui/pages/details/details-page/date-filter/date-filter.component.scss */
.filter-date {
  position: relative;
  margin-top: -5px;
  padding-right: 32px;
}
.filter-date .date-pickers {
  display: flex;
  align-items: center;
  align-items: center;
}
.filter-date .date-pickers .date-picker {
  justify-content: center;
  padding: 0px;
  border-radius: 4px;
  background-color: #fff;
  color: #000;
  font-size: 14px;
  font-weight: 700;
  line-height: 32px;
  margin-right: 16px;
}
.filter-date .date-pickers .date-picker:hover {
  background-color: #f0f0f0;
  cursor: pointer;
  transform: translateY(1px);
  transition: all 0.1s ease;
}
.filter-date p {
  color: #fff;
  font-weight: 700;
  font-size: 10px;
  line-height: 1.5;
  margin-top: 0px;
  margin-bottom: 0px;
}
.filter-date span {
  margin-left: 10px;
  margin-right: 10px;
  color: #fff;
}
.btn-date-change {
  padding: 3px 6px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.1s ease;
}
.btn-date-change:hover {
  background: #ccc;
  transform: translateY(1px);
}
.date-alert {
  padding-left: 10px;
  color: #66c;
  font-size: 14px;
}
:host ::ng-deep .mat-mdc-form-field-type-mat-date-range-input .mat-mdc-form-field-infix {
  width: 180px;
}
:host ::ng-deep .mdc-text-field--filled {
  height: 32px !important;
  padding: 0 0.75em !important;
  border-radius: 4px;
}
:host ::ng-deep .mat-date-range-input {
  padding: 0px !important;
  margin: 0px !important;
}
:host ::ng-deep .mat-mdc-form-field-infix {
  padding: 0px !important;
  margin: 0px !important;
  min-height: 32px !important;
}
:host ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
:host ::ng-deep .mat-date-range-input-inner {
  max-width: 6em !important;
}
:host ::ng-deep .mat-mdc-form-field-icon-suffix {
  padding: 0 0 0 0.5em !important;
}
:host ::ng-deep .mat-mdc-button-touch-target {
  width: 32px !important;
  height: 32px !important;
}
:host ::ng-deep .mat-mdc-icon-button.mat-mdc-button-base {
  width: 32px;
  height: 32px;
  padding: 4px;
}
/*# sourceMappingURL=date-filter.component-DJTQXDUO.css.map */
